<mat-card class="clickable smallCard" (click)="submit()" [ngClass]="{'disabled':disabled}">
    <mat-card-header class="flex align stretch">
        <div mat-card-avatar class="flex align center" >
            <ng-content select="[image]"></ng-content>
        </div>
        <div class="padleft elipsis">

            <ng-content select="[title]"></ng-content>

            <ng-content select="[subTitle]"></ng-content>

        </div>
    </mat-card-header>
</mat-card>